bam-image {
  figure.image img {
    object-fit: contain;
  }
}

.bam-image-teaser__link bal-button a {
  padding: 0 !important;
}

.bam-image-teaser__heading {
  margin-bottom: 32px !important;
}

.bam-image-teaser__item-headline-container {
  margin-top: 16px;

  @media screen and (min-width: 768px) {
    margin-top: 32px;
  }
}

.bam-image-teaser__item-headline {
  margin-bottom: 4px !important;
}
